import { Box, Button, Dialog, DialogActions, DialogContent, Divider, Icon, Typography } from "@mui/material";
import { useMatchRoute, useNavigate } from "@tanstack/react-router";
import parse from "html-react-parser";
import { X } from "react-feather";
import { useTranslation } from "react-i18next";
import { SubmitButton } from "@/components";

type NotificationsProps = {
  notificationsModalOpen: boolean;
  toggleNotificationsModal: () => void;
};

export const NotificationsModal = ({ notificationsModalOpen, toggleNotificationsModal }: NotificationsProps) => {
  const { t } = useTranslation("coi-platform-translations");
  const matchRoute = useMatchRoute();
  const navigate = useNavigate();
  const match = matchRoute({
    to: "/consent-solutions/$csId",
    fuzzy: true,
  });

  const csId = !match ? null : match.csId;

  const onRedirectToNotificationsSettings = () => {
    if (csId) {
      navigate({ to: `/consent-solutions/${csId}/settings` });
    } else {
      navigate({ to: "/consent-solutions" });
    }
    toggleNotificationsModal();
  };

  return (
    <Dialog
      open={notificationsModalOpen}
      sx={{ m: "auto" }}
      PaperProps={{
        sx: {
          width: "600px",
        },
      }}
      data-testid="settings-modal"
    >
      <Box display="flex" justifyContent="space-between" alignItems="center" padding="16px 24px">
        <Typography variant="h6" data-testid="notifications-modal__title">
          {t("notifications.modal_title")}
        </Typography>
        <Icon component="div" onClick={toggleNotificationsModal} sx={{ cursor: "pointer" }}>
          <X />
        </Icon>
      </Box>
      <Divider />
      <DialogContent sx={{ padding: "16px 24px" }}>
        <Box display="flex" flexDirection="column" gap="16px" paddingBottom="16px">
          <Typography>{t("notifications.text_1")}</Typography>
          <Typography>{parse(t("notifications.text_2"))}</Typography>
        </Box>
        <DialogActions sx={{ padding: "8px 0" }}>
          <Button variant="text" onClick={toggleNotificationsModal}>
            {t("common.close")}
          </Button>
          <SubmitButton onClick={onRedirectToNotificationsSettings}>
            {parse(
              csId
                ? t("notifications.modal.redirect_to_settings")
                : t("notifications.modal.redirect_to_consent_solutions"),
            )}
          </SubmitButton>
        </DialogActions>
      </DialogContent>
    </Dialog>
  );
};
